import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconManagementLine = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3337 5H16.9195L13.0004 8.91912L10.3742 6.29289C10.1866 6.10536 9.93228 6 9.66707 6C9.40185 6 9.1475 6.10536 8.95996 6.29289L3.95996 11.2929L5.37417 12.7071L9.66707 8.41421L12.2933 11.0404C12.4808 11.228 12.7352 11.3333 13.0004 11.3333C13.2656 11.3333 13.52 11.228 13.7075 11.0404L18.3337 6.41421V8H20.3337V4C20.3337 3.44772 19.886 3 19.3337 3H15.3337V5ZM15.3337 13H16.9195L13.0004 16.9191L10.3742 14.2929C10.1866 14.1054 9.93228 14 9.66707 14C9.40185 14 9.1475 14.1054 8.95996 14.2929L3.95996 19.2929L5.37417 20.7071L9.66707 16.4142L12.2933 19.0404C12.4808 19.228 12.7352 19.3333 13.0004 19.3333C13.2656 19.3333 13.52 19.228 13.7075 19.0404L18.3337 14.4142V16H20.3337V12C20.3337 11.4477 19.886 11 19.3337 11H15.3337V13Z"
        />
      </svg>
    );
  }
);
